import { _ as r } from "../internals/export.js";
import { n } from "../internals/number-parse-int.js";
r({
  global: !0,
  forced: parseInt != n
}, {
  parseInt: n
});